<template>
  <div class="main-wrap no-padding">
    <div class="top-search">
      <span class="lable">{{ activeTab === 0 ? $lang('下单日期') : $lang('揽收日期') }}</span>
      <el-date-picker
        :clearable="false"
        v-model="searchParam.date"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        :range-separator="$lang('至')"
        :start-placeholder="$lang('开始日期')"
        :end-placeholder="$lang('结束日期')"
        class="commonSize"
        @change="selectDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-button style="margin-left: 24px" type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }} </el-button>
      <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
      <div class="switch-tab">
        <el-radio-group v-model="activeTab" @change="changeTab">
          <el-radio-button :label="0">{{ $lang('我的订单') }}</el-radio-button>
          <el-radio-button :label="1">{{ $lang('我的运单') }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="sub-main">
      <div class="baseFunIcon">
        <div class="total-lf">
          <span class="num">{{ formatNumber(total) }}</span>
          <span class="text">{{ activeTab === 0 ? $lang('订单总量') : $lang('运单总量') }}</span>
        </div>
        <div class="total-rt">
          <el-row>
            <el-col :span="6" v-for="(item, index) in totalRowData" :key="index" @click.native="goPage(item)">
              <div :class="[index < 4 && 'border-rb', index === 4 && 'border-bt', index > 4 && 'border-rt']">
                <span class="num">{{ formatNumber(item.count) }}
                  <span v-if="item.scaleCount" class="num1">{{ item.scaleCount }}</span>
                </span>
                <span class="text">{{ $lang(item.name) }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="baseFunCheck">
        <div class="check-left">
          <div class="tabs">
            <div :class="[activeIndex === 1 ? 'active' : '', 'tab-btn']" @click="tabsHandler(1)">{{ $lang('省份排名') }}</div>
            <div :class="[activeIndex === 2 ? 'active' : '', 'tab-btn']" @click="tabsHandler(2)">{{ $lang('城市排名') }}</div>
          </div>
          <div class="tabs-content">
            <div class="header">
              <el-row>
                <el-col :span="5">{{ $lang('排名') }}</el-col>
                <el-col :span="9">{{ activeIndex === 1 ? $lang('省份') : $lang('城市') }}</el-col>
                <el-col :span="10">{{ $lang('订单量') }}</el-col>
              </el-row>
            </div>
            <div class="tables" v-loading="loading">
              <el-row v-for="(item, index) in countTopTenData" :key="index">
                <el-col :class="{ top: index < 3 }" :span="5">{{ index + 1 }}</el-col>
                <el-col class="province" :span="9">
                  <el-tooltip class="item" effect="dark" :content="$lang(item.regionName)" placement="top">
                    <div>{{ $lang(item.regionName) }}</div>
                  </el-tooltip>
                </el-col>
                <el-col class="order-th" :span="10">
                  <el-progress class="lines" :show-text="false" :percentage="index === 0 ? 100 : (100 / countTopTenData[0].quantity) * item.quantity"></el-progress>
                  <!-- <span class="lines"></span> -->
                  <span>{{ formatNumber(item.quantity) }}</span>
                </el-col>
              </el-row>
              <div style="text-align: center; margin-top: 100px" v-if="!countTopTenData.length">
                {{ $lang('暂无数据') }}
              </div>
            </div>
          </div>
        </div>
        <div class="check-right">
          <v-chart ref="pieChart" :options="pieOption" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants/index'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import { getOrderCountTopTen, getOrderTrendChartList, getCountByStatus, waybillCountByStatus, waybillCountTopTen, waybillTrendChartList } from '@api/module/customer'

export default {
  name: 'Home',
  components: {
    'v-chart': ECharts,
  },
  data () {
    let _minTime = null
    let _maxTime = null
    const maxTime = this.$dayjs(new Date().getTime()).format('YYYY-MM-DD') + ' 23:59:59'
    return {
      activeTab: 0,
      searchParam: {
        date: this.$common.commonFun.GetTodayDate(),
        startTime: this.$common.commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: this.$common.commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
      },
      activeIndex: 1,
      date: '',
      pickerOptions: {
        disabledDate (time) {
          if (_minTime && _maxTime) {
            return time.getTime() < _minTime || time.getTime() > _maxTime
          }
          return time.getTime() > maxTime
        },
        onPick ({ maxDate, minDate }) {
          // 如果选择了只选择了一个时间
          if (!maxDate) {
            const timeRange = 30 * 24 * 60 * 60 * 1000 // 31天
            _minTime = minDate.getTime() - timeRange // 最小时间
            _maxTime = minDate.getTime() + timeRange > new Date() ? maxTime : minDate.getTime() + timeRange// 最大时间
            // 如果选了两个时间，那就清空本次范围判断数据，以备重选
          } else {
            _minTime = _maxTime = null
          }
        },
      },
      xAxisData: [],
      seriesData: [],
      total: 0,
      countTopTenData: [],
      loading: false,
      totalRowData: [],
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      return this.$store.state.base.user || {}
    },
    pieOption () {
      return {
        grid: {
          top: 100,
        },
        title: {
          zlevel: 0,
          text: this.activeTab === 0 ? this.$lang('订单量走势（票）') : this.$lang('运单量走势（票）'),
          rich: {
            value: {
              color: '#333',
              fontSize: 32,
              fontWeight: 'bold',
            },
            name: {
              color: '#999',
            },
          },
          top: '10',
          left: '10',
          textAlign: 'left',
          textStyle: {
            rich: {
              value: {
                color: '#333',
                fontSize: 32,
                fontWeight: 'bold',
                lineHeight: 32,
              },
              name: {
                color: '#999',
                lineHeight: 20,
              },
            },
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          top: 50,
          orient: 'vertical',
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: this.$t('票数'),
            type: 'bar',
            barMaxWidth: 20,
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
            data: this.seriesData,
          },
        ],
      }
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    // 订单数据
    init() {
      this.getOrderCountTopTen()
      this.getOrderTrendChartList()
      this.getCountByStatus()
      const _this = this
      window.onresize = function () {
        _this.$refs.pieChart.resize()
      }
    },
    // 运单数据
    getWaybillData() {
      this.getWaybillCountBystatus()
      this.getWaybillCountTopTen()
      this.getWaybillTrendChartList()
    },
    // 订单、运单切换
    changeTab(val) {
      this.activeIndex = 1
      if (val === 0) {
        this.init()
      } else {
        this.getWaybillData()
      }
    },
    /**
     * 获取运单省份和城市Top
     * regionType 1 省份  2 城市
     *
     */
    async getWaybillCountTopTen(regionType = 1) {
      try {
        this.loading = true
        const { code, data, msg } = await waybillCountTopTen({
          regionType,
          startDate: this.searchParam.startTime,
          endDate: this.searchParam.endTime,
        })
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.countTopTenData = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) { this.loading = false }
    },
    // 获取运单量走势接口
    async getWaybillTrendChartList() {
      try {
        this.$refs.pieChart.showLoading()
        const { code, data, msg } = await waybillTrendChartList({
          startDate: this.searchParam.startTime,
          endDate: this.searchParam.endTime,
        })
        this.$refs.pieChart && this.$refs.pieChart.hideLoading()
        if (code === RESPONSE_SUCCESS) {
          this.xAxisData = data.timeDatas ? data.timeDatas.map(({ time }) => time) : []
          this.seriesData = data.timeDatas ? data.timeDatas.map(({ quantity }) => quantity) : []
          this.total = data.total
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        this.$refs.pieChart && this.$refs.pieChart.hideLoading()
      }
    },
    // 获取运单状态和总数
    async getWaybillCountBystatus() {
      try {
        const { code, data, msg } = await waybillCountByStatus({
          startTime: this.searchParam.startTime,
          endTime: this.searchParam.endTime,
          timeType: 2
        })
        if (code === RESPONSE_SUCCESS) {
          this.total = data[0].count
          this.totalRowData = data.slice(1).map(item => {
            item.name = item.waybillStatusName
            item.type = 'waybill'
            return item
          })
        } else {
          this.$message.error(msg)
        }
      } catch (error) { console.log(error) }
    },
    // TODO 测试数据
    testGenerateData () {
      let i = 0
      while (i < 30) {
        this.xAxisData.unshift(new Date(new Date().setDate(new Date().getDate() - i)).toLocaleDateString())
        const n = Math.floor(Math.random() * 9999999 + 1)
        this.seriesData.push(n)
        i++
      }
    },
    goPage (item) {
      const homeQuery = JSON.stringify({ ...item, ...this.searchParam })
      if (item.type === 'order') {
        sessionStorage.setItem('homeQuery', homeQuery)
      } else {
        sessionStorage.setItem('waybillHomeQuery', homeQuery)
      }
      this.$router.push({ path: `/${item.type}` })
    },
    /**
     * 获取省份和城市Top
     * regionType 1 省份  2 城市
     *
     */
    async getOrderCountTopTen (regionType = 1) {
      try {
        this.loading = true
        const res = await getOrderCountTopTen({
          regionType,
          startDate: this.searchParam.startTime,
          endDate: this.searchParam.endTime,
        })
        this.loading = false
        if (res && res.succ) {
          this.countTopTenData = res.data
        }
      } catch (error) {
        this.loading = false
      }
    },
    // 获取图表和订单总量
    async getOrderTrendChartList () {
      try {
        this.$refs.pieChart.showLoading()
        const res = await getOrderTrendChartList({
          startDate: this.searchParam.startTime,
          endDate: this.searchParam.endTime,
        })
        this.$refs.pieChart && this.$refs.pieChart.hideLoading()
        if (res && res.succ) {
          this.xAxisData = res.data.timeDatas ? res.data.timeDatas.map(({ time }) => time) : []
          this.seriesData = res.data.timeDatas ? res.data.timeDatas.map(({ quantity }) => quantity) : []
          this.total = res.data.total
        }
      } catch (error) {
        console.log(error)
        this.$refs.pieChart && this.$refs.pieChart.hideLoading()
      }
    },
    // 状态和总数
    async getCountByStatus () {
      try {
        const res = await getCountByStatus({
          startDate: this.searchParam.startTime,
          endDate: this.searchParam.endTime,
        })
        if (res && res.succ) {
          const orderStatusList = res.data.orderStatusList.slice(1).map(item => {
            item.count = item.total
            item.name = item.orderStatusName
            item.type = 'order'
            return item
          })
          const waybillStatusList = res.data.waybillStatusList.slice(1).map(item => {
            item.name = item.waybillStatusName
            item.type = 'waybill'
            return item
          })
          this.totalRowData = [...orderStatusList, ...waybillStatusList]
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatNumber (str) {
      return this.$common.formatNumber(str)
    },
    resetSearch () {
      this.searchParam = {
        date: this.$common.commonFun.GetTodayDate(),
        startTime: this.$common.commonFun.GetTodayDate()[0],
        endTime: this.$common.commonFun.GetTodayDate()[1],
      }
    },
    searchChange () {
      if (this.activeTab === 0) {
        this.getOrderCountTopTen()
        this.getOrderTrendChartList()
        this.getCountByStatus()
      } else {
        this.getWaybillData()
      }
    },
    // 选择日期
    selectDate () {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startTime = start
        this.searchParam.endTime = end
      }
    },
    tabsHandler (index) {
      this.activeIndex = index
      if (this.activeTab === 0) {
        this.getOrderCountTopTen(index)
      } else {
        this.getWaybillCountTopTen(index)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content .main-wrap {
  height: calc(100vh - 65px);
}
.top-search {
  padding: 24px;
}

.lable {
  display: inline-block;
  margin-right: 20px;
}

.switch-tab {
  float: right;
}
.sub-main {
  padding: 16px 24px 24px;
  background: #edeef3;
}
.baseHeader {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  padding-left: 24px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eeeeee;
}
.baseFunIcon {
  display: flex;
  padding: 24px;
  display: flex;
  background: #fff;
  height: 224px;
  .baseFunIconItem {
    padding: 25px 0;
    width: 142px;
    height: 92px;
    text-align: center;
    text-align: -webkit-center;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      border-color: rgba(224, 189, 123, 0.3);
    }
    .warp {
      width: 60px;
      height: 60px;
      line-height: 60px;
      border-radius: 50%;
      text-align: center;
      background: rgba(224, 189, 123, 0.2);
      color: #e0bd7b;
      margin-bottom: 10px;
    }
    .text {
      color: #999999;
      font-size: 12px;
    }
    .iconfont {
      font-size: 24px;
    }
  }
}
.border-rb {
  border-right: 1px solid #dcdee1;
  border-bottom: 1px solid #dcdee1;
}
.border-rt {
  border-right: 1px solid #dcdee1;
}
.border-bt {
  border-bottom: 1px solid #dcdee1;
}
.total-lf {
  flex: 0 0 360px;
  padding-left: 15px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:hover {
    background: #edeef3;
  }
  .num {
    font-size: 56px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #e60012;
    line-height: 68px;
  }
  .text {
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 30px;
    margin-top: 24px;
  }
}
.total-rt {
  flex: 1;
  .el-col-6 {
    width: 20% !important;
    div {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      justify-content: center;
      height: 112px;
      cursor: pointer;
      &:hover {
        background: #edeef3;
      }
      .num {
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #e60012;
        line-height: 30px;
      }
      .num1 {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: black;
        line-height: 30px;
        display: inline-block;
        margin-left: 10px;
      }
      .text {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #666666;
        line-height: 18px;
        margin-top: 16px;
      }
    }
  }
}
.baseFunCheck {
  margin-top: 16px;
  display: flex;
  height: 642px;
  width: 100%;
  .check-left {
    margin-right: 16px;
    flex: 0 0 480px;
    background: #fff;
    .tabs {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 20px;
      padding: 17px 24px;
      border-bottom: 1px solid #d8d8d8;
      .tab-btn {
        margin-right: 40px;
        cursor: pointer;
        &.active {
          position: relative;
          font-size: 18px;
          font-weight: 600;
          line-height: 22px;
          &::before {
            content: '';
            position: absolute;
            bottom: -17px;
            width: 24px;
            height: 3px;
            background: #e60012;
            border-radius: 2px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .tabs-content {
      .header {
        .el-row {
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 16px;
          padding: 12px 0;
          border-bottom: 1px solid #d8d8d8;
          .el-col-5 {
            padding-left: 48px;
          }
          .el-col-10 {
            padding-left: 7px;
          }
        }
      }
      .tables {
        font-size: 14px;
        font-family: ArialMT, ArialMT-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 18px;
        .el-row {
          padding: 15px 0;
          .el-col-5 {
            padding-left: 48px;
            position: relative;
            &.top {
              position: relative;
              &::before {
                content: 'TOP';
                position: absolute;
                left: 13px;
                top: 50%;
                transform: translateY(-50%);
                width: 32px;
                height: 14px;
                background: #e60012;
                border-radius: 7px;
                font-size: 10px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 14px;
              }
            }
          }
          .province .el-tooltip {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .order-th {
            display: flex;
            align-items: center;
            padding-left: 7px;
            ::v-deep .lines {
              margin-right: 8px;
              width: 100px;
              height: 8px;
              // background: linear-gradient(270deg, #59b3ff, #2d7cff);
              border-radius: 5px;
              .el-progress-bar__outer {
                height: 8px !important;
                border-radius: 5px;
                .el-progress-bar__inner {
                  background: linear-gradient(270deg, #59b3ff, #2d7cff);
                }
              }
            }
          }
        }
      }
    }
  }
  .check-right {
    flex: 1;
    background: #fff;
    .echarts {
      width: 100%;
      height: calc(100% - 41px);
    }

    .check-right-hd {
      overflow: hidden;
      ul {
        overflow: hidden;
        padding: 0;
        float: right;
        list-style: none;
        font-size: 12px;
        font-weight: normal;
        margin: 0;
        li {
          float: left;
          color: #666;
          margin-right: 10px;
        }
        .active {
          color: #e0bd7b;
        }
      }
    }
  }
}
@media (max-width: 1400px) {
  .baseFunCheck {
    .check-right {
      .echarts {
        max-width: 100%;
        width: 100%;
      }
    }
  }
}
</style>
